module.exports = __webpack_public_path__ + "static/media/landingCollaborator10.4f7012af.jpg";